import Vue from 'vue'
import axios from 'axios'
import tabler from './components/tabler.vue'
import tablerscroll from './components/tablerscroll.vue'
import selector from './components/selector.vue'
import pagefilter from './components/pagefilter.vue'
import commenter from './components/commenter.vue'
import progresser from './components/progresser.vue'
import glyph from './components/glyph.vue'
import bbtn from './components/bbtn.vue'
import inputform from './components/inputform.vue'
import ActionDialog from "./components/ActionDialog";
import Chooser from './components/Chooser';
import IsPanel from './components/IsPanel';
import Select2 from 'v-select2-component'
import moment from 'moment'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import DataReceiver from './js/datareceiver.js'
import RadialProgressBar from 'vue-radial-progress'
import BootstrapToggle from 'vue-bootstrap-toggle'
import VueContext from 'vue-context'
import { Drag, Drop} from 'vue-drag-drop'
import VueResizable from 'vue-resizable'
import qs from 'qs'
import * as uiv from 'uiv'
import uidialog from './components/UiDialog'
import usergroupchooser from './components/UsergroupChooser.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'
import WrappedComponent from 'vue-wrapped-component'
import { VTooltip as VTip } from 'v-tooltip'
import "./css/tooltip.css"
import draggable from "vuedraggable"
import vuejsStorage from 'vuejs-storage'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import { mapGetters } from 'vuex'
import createPersistedState from "vuex-persistedstate"
import Editor from '@tinymce/tinymce-vue'
require('json-circular-stringify')
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import suggest from "./components/suggest";
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import VueBarcode from 'vue-barcode'
import VueHtmlToPaper from 'vue-html-to-paper'
import './css/fontawesome.min.css'
import 'leaflet/dist/leaflet.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import InfiniteScroll from 'v-infinite-scroll'
import httpVueLoader from 'http-vue-loader'
import BurgerMenu from './components/BurgerMenu'
import { LMap, LTileLayer, LMarker,LIcon,LFeatureGroup,LTooltip,LGeoJson } from 'vue2-leaflet';
import L from 'leaflet';
import VueImg from 'v-img';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
//import VGeosearch from 'vue2-leaflet-geosearch';
import GetTextPlugin from 'vue-gettext'
import {translate} from 'vue-gettext'
import Vue2TouchEvents from 'vue2-touch-events'
import VueMobileDetection from "vue-mobile-detection"
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueSpeedometer from "vue-speedometer"
import * as ModalDialogs from 'vue-modal-dialogs'
import ModalDialog from "./components/ModalDialog.vue"
import ClickOutside from 'vue-click-outside'

const messageBox=ModalDialogs.create(ModalDialog,'content');
export default {
    install(Vue) {
      Vue.component("tabler", tabler);
      Vue.component("tablerscroll", tablerscroll);
      Vue.component("selector", selector);
      Vue.component("pagefilter", pagefilter);
      Vue.component("commenter", commenter);
      Vue.component("select2",Select2);
      Vue.component("dropzone",vue2Dropzone);
      Vue.component("RadialProgressBar",RadialProgressBar);
      Vue.component("toggle",BootstrapToggle);
      Vue.component("context",VueContext);
      Vue.component("progresser",progresser);
      Vue.component("usergroupchooser",usergroupchooser);
      Vue.component("ispanel",IsPanel);
      Vue.component("drag",Drag);
      Vue.component("drop",Drop);
      Vue.component("glyph",glyph);
      Vue.component("bbtn",bbtn);
      Vue.component("inputform",inputform);
      Vue.component("vue-resizable",VueResizable);
      Vue.component("datepicker",DatePicker);
      Vue.component("wrapped-component",WrappedComponent);
      VTip.options.defaultClass='tooltip-vue';
      VTip.options.defaultTemplate="<div class=\"tooltip-vue\" role=\"tooltip\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\"></div></div>";
      Vue.directive("tip",VTip);
      Vue.directive("click-outside",ClickOutside);
      Vue.component("draggable",draggable);
      Vue.component("tinymce",Editor);
      Vue.component("actiondialog",ActionDialog);
      Vue.component("chooser",Chooser);
      Vue.component("suggest",suggest);
      Vue.component('typeahead', VueBootstrapTypeahead);
      Vue.component('barcode',VueBarcode);
      Vue.component('speedometer',VueSpeedometer);
      Vue.use(VueHtmlToPaper);
      Vue.use(httpVueLoader);

      Vue.use(Viewer);
      Vue.use(uiv);
      Vue.use(vuejsStorage);
      Vue.use(Vuex);
      Vue.use(InfiniteScroll);
      Vue.use(VueLodash,{ lodash:lodash });
      Vue.use(VueImg);
      Vue.use(VueMobileDetection);
      Vue.use(ModalDialogs);

      Vue.component("uidialog",uidialog);
      Vue.component("fullcalendar",FullCalendar);
      Vue.component("treeselect",Treeselect);
      Vue.component("burgermenu",BurgerMenu);
      Vue.config.devtools = true;
      Vue.filter("dateformat",(value, format) => {
        if (format == null) format = "DD.MM.YYYY";
        if (value)
          return moment(String(value)).format(format);
      });
      library.add(fas, far, fab);
      Vue.component('font-awesome-icon', FontAwesomeIcon);
      Vue.component('l-map', LMap);
      Vue.component('l-tile-layer', LTileLayer);
      Vue.component('l-marker', LMarker);
      Vue.component('l-icon', LIcon);
      Vue.component('l-tooltip', LTooltip);
      Vue.component('l-feature-group', LFeatureGroup);
      Vue.component('l-geo-json', LGeoJson);
//      Vue.component('VGeosearch',VGeosearch);

      Vue.use(Vue2TouchEvents);

      var VueGesture=require('vue2-gesture');
      Vue.use(VueGesture);
    }
}

export { axios,moment,DataReceiver,qs,dayGridPlugin,interactionPlugin,bootstrapPlugin,VueRouter,Vuex,mapGetters,createPersistedState,lodash,httpVueLoader,L,OpenStreetMapProvider,GetTextPlugin,VueReCaptcha,ModalDialogs,messageBox,translate };